import { Switch as SwitchNext} from "@nextui-org/switch";
import { Controller } from "react-hook-form";

export const Switch = props => {
  const { name, defaultSelected = false, children, control = null, ...rest } = props;

  return (
    <>   
      {control ? (
        <Controller
          name={name}
          control={control}
          rules={{
            required: true,
          }}
          value={defaultSelected}
          render={({ field: { onChange, onBlur, value } }) => (
            <SwitchNext 
              onChange={(event) => { 
                onChange(event.target.checked);
              }}
              defaultSelected={value}
              {...rest}
            >
              {children}
            </SwitchNext>
          )}
        />) : (
          <SwitchNext
            {...rest}
            defaultSelected={defaultSelected}
          >
            {children}
          </SwitchNext>
        )}
    </>
  );
};

export default Switch;